/**
 * Build version order, as vms_database's updatestatus.Compare answers it, so
 * the UI and the cloud agree on which servers are behind a release.
 */

/** Numeric fields in a build version, as in 0.9.0.1234. */
const VERSION_FIELD_COUNT = 4;

function parse(s: string | undefined): number[] | null {
    const fields = (s ?? '').trim().split('.');
    if (fields.length !== VERSION_FIELD_COUNT || fields.some((f) => !/^\d+$/.test(f))) {
        return null;
    }
    return fields.map(Number);
}

/** A malformed version is older than every valid one, so it reads as behind. */
export function compareVersions(a?: string, b?: string): -1 | 0 | 1 {
    const left = parse(a);
    const right = parse(b);
    if (!left || !right) {
        if (left) {
            return 1;
        }
        if (right) {
            return -1;
        }
        return 0;
    }
    for (let i = 0; i < VERSION_FIELD_COUNT; i += 1) {
        const one = left[i] ?? 0;
        const other = right[i] ?? 0;
        if (one !== other) {
            return one > other ? 1 : -1;
        }
    }
    return 0;
}

/** The target or newer: what the cloud counts as done, since nothing downgrades. */
export function runsAtLeast(version: string | undefined, target: string): boolean {
    return compareVersions(version, target) >= 0;
}
